module.exports = __webpack_public_path__ + "static/img/detail-luolan.fe5e77aa.png";